module.exports = __webpack_public_path__ + "static/media/notekeeper.7ff550b7.png";